let token;
try {
    token = require('@servicetitan/launchdarkly-service').LD_SERVICE_TOKEN;
}
catch (e) {
    // ignore
}
export function getLDServiceToken() {
    return token;
}
//# sourceMappingURL=get-ld-service-token.js.map